export default __webpack_public_path__ + "static/appstore-00318af81021c04e4cc7b408077bb582.png";